import commentsApi from "@/api/comment";

const state = {
    isLoading: false,
    isMore: null,
    nextPage: 1,
    comments: null,
}
export const mutationTypes = {
    clearComments: '[comments] clearComments',
    appendComments: '[comments] appendComments',
    setIsLoading: '[comments] setIsLoading',
    setIsMore: '[comments] setIsMore',
    setNextPage: '[comments] setNextPage'
}
export const actionTypes = {
    getComments: '[comments] getComments',
}

export const getterTypes = {
    comments: '[comments] comments',
    isLoading: '[comments] isLoading',
    isMore: '[comments] isMore'
}
const mutations = {
    [mutationTypes.appendComments](state, orders) {
        if (state.comments === null){
            const arrProxy = new Proxy(orders, {
              get(target, prop) {
                if (prop === 'push') {
                  return (...args) => {
                    console.log(...args);
                    return target[prop](...args);
                  };
                }
                return target[prop];
              }
            });
            state.comments = arrProxy
        } else {
            orders.forEach((order) => {
                const found = state.comments.find((element) => element.id === order.id);
                if (!found){
                    state.comments.push(order)
                }
            })
        }
    },
    [mutationTypes.clearComments](state){
        state.comments = null
        state.nextPage = 1
        state.isMore = null
    },
    [mutationTypes.setIsLoading](state, value){
        state.isLoading = value
    },
    [mutationTypes.setIsMore](state, value){
        state.isMore = value
    },
    [mutationTypes.setNextPage](state, value){
        state.nextPage = value
    }
}

const getters = {
    [getterTypes.comments]: state => {
        return state.comments
    },
    [getterTypes.isLoading]: state => {
        return state.isLoading
    },
    [getterTypes.isMore]: state => {
        return state.isMore
    }
}

const actions = {
    [actionTypes.getComments](context, credentials) {
        context.commit(mutationTypes.setIsLoading, true)
        if (state.nextPage){
            credentials.page = state.nextPage
        }
        return new Promise(resolve => {
            commentsApi
                .getComments(credentials)
                .then(response => {
                    console.log('response:', response)

                    context.commit(mutationTypes.appendComments, response.data['results'])
                    context.commit(mutationTypes.setIsLoading, false)

                    if (response.data['next']){
                        context.commit(mutationTypes.setIsMore, true)
                        const url = new URL(response.data['next']);
                        const urlParams = new URLSearchParams(url.search);
                        const nextPage = parseInt(urlParams.get('page'))
                        context.commit(mutationTypes.setNextPage, nextPage)
                        console.log('Next page:', nextPage)
                    } else {
                        context.commit(mutationTypes.setNextPage, null)
                        context.commit(mutationTypes.setIsMore, false)
                    }
                    resolve(response.data['results'])
                })
                .catch(result => {
                    context.commit(mutationTypes.setIsLoading, false)
                    console.log('Result Errors:', result)
                })
        })
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}